import * as React from 'react';

/**
 * The DOM node a floating surface (popover, select, dropdown menu, hover card)
 * should portal into — `null` meaning Radix's default, `document.body`.
 *
 * Portaling to the body puts the floating element in a stacking context that is
 * a *sibling* of the modal it was opened from, so whether it shows up at all
 * comes down to which of the two carries the higher z-index. That race is how
 * STMN-3759 happened: a column's date range picker (popover, `z-50`) opened
 * from a table expanded into a dialog (overlay, `z-[60]`) rendered behind the
 * overlay, and the filter looked dead. So a modal publishes its own content
 * node here, and anything floating opened from inside it renders *within* it,
 * where DOM order — not a global z-index scale — puts it on top.
 */
const PortalContainerContext = React.createContext<HTMLElement | null>(null);

export const PortalContainerProvider = PortalContainerContext.Provider;

export const usePortalContainer = () =>
  React.useContext(PortalContainerContext);
